/**
 * Constant values for working with reusable styles.
 */
// TODO(carter): line heights
export var fontSizes = {
    mini: '.5rem',
    small: "".concat(10 / 16.0, "rem"),
    medium: "".concat(14 / 16.0, "rem"),
    semiBig: "".concat(18 / 16.0, "rem"),
    big: "".concat(20 / 16.0, "rem"),
    giant: "".concat(24 / 16.0, "rem"),
    jumbo: "".concat(40 / 16.0, "rem"),
};
export var fontWeights = {
    light: "300",
    semiBold: "400",
    bold: "600",
    extraBold: "800",
};
// Accent colors
var accentTeal = '#009BB5'; // Accent-Teal, AKA Light Gradient 1
var accentMint = '#3FB79C'; // Accent-Mint, AKA Light Gradient 2
var accentOrange = '#F9A758'; // Accent-Orange
var accentYellow = '#F7C700'; // Accent-Yellow
var accentRed = '#F56E60'; // Accent-Red
// Primary colors
var primaryBlue = '#003975'; // Primary-Blue. Used inTitles, text
var primaryGreyDark = '#576C82'; // Primary-Grey-Dark // Buttons, text
var primaryGreyMediumDark = '#8799AB'; // Primary-Grey-Mid-Dark // Icons for nav
var primaryGreyMediumLight = '#CBD2DB'; // Primary-Grey-Mid-Light
var primaryGreyLight = '#E4E7ED'; // Primary-Grey-Light // Borders
var primaryWhite = '#F6F6F7'; // Primary-White
// Whites
var trueWhite = '#FFFFFF'; // True-white
var trueBlack = '#000000'; // True-black
// Brand colors (eventually white-labeled)
var brandPrimary = '#5B689F'; // Primary, Main Gradient 1
var brandSecondary = '#95CEDC'; // Secondary; Main Gradient 2
export var colors = {
    accentTeal: accentTeal,
    accentMint: accentMint,
    accentOrange: accentOrange,
    accentYellow: accentYellow,
    accentRed: accentRed,
    primaryBlue: primaryBlue,
    primaryGreyDark: primaryGreyDark,
    primaryGreyMediumDark: primaryGreyMediumDark,
    primaryGreyMediumLight: primaryGreyMediumLight,
    primaryGreyLight: primaryGreyLight,
    primaryWhite: primaryWhite,
    trueWhite: trueWhite,
    trueBlack: trueBlack,
    brandPrimary: brandPrimary,
    brandSecondary: brandSecondary,
};
